module.exports = __webpack_public_path__ + "static/elephant4-502ffd63407f385cd17629d136ce0533.jpeg";